export const itemsBaseApiPath = '/api/manage/common/fulfillment/batches';

import {
  fetchItemsGen
} from '../../../utils/apiHelperGenerators.js';

export const fetchItems = fetchItemsGen(itemsBaseApiPath, 'listItems');

export default {
  fetchItems
};
